import { createSlice } from "@reduxjs/toolkit";

interface InviteInitialStateModel {
  filter:any;
}
const InviteInitialState: InviteInitialStateModel = {
  filter:{
    PageIndex:1,
    PageSize:20,
  

  }
};

const inviteSlice = createSlice({
  name: "InviteSlice ",
  initialState: InviteInitialState,
  reducers: {
    handleSetInviteFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    handleResetInviteFitler: (state, ) => {
      state.filter = {
        PageIndex:1,
        PageSize:20,
        SortProperty:"InsertDate",
        SortType:"asc"
      };
    },
  },
});

export const {
  handleSetInviteFilter,
  handleResetInviteFitler,
} = inviteSlice.actions;
export default inviteSlice;
